module.exports = __webpack_public_path__ + "static/img/BK7.d9fb37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK7.png
// module id = CodJ
// module chunks = 9